import React, { useEffect, useState } from 'react'; // eslint-disable-line

import noAnalyticsLogo from '../../assets/images/svg/no-analytics.svg';

export const AnalyticsFeatureGuard = ({ children, token, analyticsApiUrl, productType, flags, isUnity }) => {
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [error, setError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetch(`${analyticsApiUrl}api/IsAuthorized?platformId=${productType}&isUnity=${isUnity}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            method: 'post',
            }).then(response => {
                if (response.ok) {
                    setIsAuthorized(true);
                }
                else if (response.status === 401) {
                    setIsAuthorized(false);
                }
                else if (response.status >= 500) {
                    setError(true);
                }
                setIsLoading(false);
            }).catch((error) => {
                setError(true); 
                setIsLoading(false);
            });
    }, [token, analyticsApiUrl, productType]);

    if (flags?.results?.analytics === undefined || isLoading) {
        return <>Loading...</>;
    }

    let message = '';
    if (!isLoading && error) { 
        message = 'An error has occurred retrieving analytics. Please try again.';
    }
    else if (!flags?.results?.analytics) {
        message = 'Your organization is not configured for analytics. Please contact your administrator.';
    }
    else if (!isAuthorized && !isLoading) { 
        message = 'You are not authorized to use analytics. Please contact your administrator';
    }
    else if (!token) { 
        message = 'Your token has expired is invalid or missing. Please log in again.';
    }

    if (message) {
        return (<>
            <img src={`${noAnalyticsLogo}`} alt={message}/>
            <div>{message}</div>
        </>);
    }

    return <>{ children }</>;
}
